import styled from 'components/_UI/designSystem';

// components
import { Flexbox, Select } from 'components/spaceKit';

export const StyledForm = styled(Flexbox)`
    min-width: 300px;
`;
export const StyledInputWrap = styled(Flexbox)`
    max-width: 100px;
`;
export const StyledSelect = styled(Select)`
    height: 40px;
`;
